// extracted by mini-css-extract-plugin
module.exports = {"w1y6gb3a":"w1y6gb3a","b1yrydy7":"b1yrydy7","b2yk6ki":"b2yk6ki","b15azh7j":"b15azh7j","chnwx4l":"chnwx4l"};